export default __webpack_public_path__ + "static/media/dollar-sign.04bd797e.svg";